<!-- components/GlobalDialog.vue -->
<template>
  <transition name="fade">
    <div v-if="visible" class="dialog-overlay" @click.self="hide">
      <div class="dialog-box" :class="type">

        <div class="dialog-header">
          <span class="dialog-icon">{{ icon }}</span>
          <h3>{{ title }}</h3>
          <button class="dialog-close" @click="hide">✕</button>
        </div>

        <div class="dialog-body">
          <p v-html="message"></p>
        </div>

        <div class="dialog-footer">
          <button class="btn-ok" @click="hide">OK</button>
        </div>

      </div>
    </div>
  </transition>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'GlobalDialog',
  computed: {
    ...mapState('app', ['visible', 'title', 'message', 'type']),
    icon () {
      return { error: '❌', warning: '⚠️', info: 'ℹ️', success: '✅' }[this.type]
    }
  },
  methods: {
    ...mapActions('app', ['hideDialog']),
    hide () {
      this.hideDialog()
    }
  }
}
</script>

<style scoped>
.dialog-overlay {
  position: fixed; inset: 0;
  background: rgba(0,0,0,0.5);
  display: flex; align-items: center; justify-content: center;
  z-index: 9999;
}
.dialog-box {
  background: #fff; border-radius: 8px;
  min-width: 350px; max-width: 530px;
  box-shadow: 0 8px 32px rgba(0,0,0,0.2);
  overflow: hidden;
}
.dialog-header {
  display: flex; align-items: center; gap: 8px;
  padding: 16px 20px;
  border-bottom: 1px solid #eee;
}
.dialog-icon {
  font-size: 21px;
}
.dialog-header h3 { margin: 0; flex: 1; font-size: 28px; color: #1976d2; }
.dialog-close { background: none; border: none; cursor: pointer; font-size: 16px; }
.dialog-body { padding: 20px; }
.dialog-body p { font-size: 22px; line-height: 30px; color: #5b5757; }
.dialog-footer { padding: 12px 20px; text-align: right; border-top: 1px solid #eee; }
.btn-ok {
  padding: 8px 24px; border: none; border-radius: 4px;
  cursor: pointer; font-size: 14px; color: #fff; background: #1976d2;
}

/* Kolory wg typu */
.error   .dialog-header { background: #fdecea; }
.warning .dialog-header { background: #fff8e1; }
.info    .dialog-header { background: #e3f2fd; }
.success .dialog-header { background: #e8f5e9; }

/* Animacja */
.fade-enter-active, .fade-leave-active { transition: opacity .25s; }
.fade-enter, .fade-leave-to { opacity: 0; }
</style>



// WEBPACK FOOTER //
// src/components/Dialogs/GlobalDialog.vue